import { COUNTRY_CODES } from '../../common/constants';

export default function canShowPrivacyOptions(country) {
  // Privacy options link / form can only be shown to US residents
  return country === COUNTRY_CODES.USA;
}
